"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLazyLoadImage = exports["default"] = exports.BACKGROUND_IMG_ATTR = exports.ATTACHMENT_IMG_ATTR = exports.EXTERNAL_IMG_ATTR = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = require("react");

require("intersection-observer");

var errorCaches = new Set();
var EXTERNAL_IMG_ATTR = 'data-src';
exports.EXTERNAL_IMG_ATTR = EXTERNAL_IMG_ATTR;
var ATTACHMENT_IMG_ATTR = 'cid';
exports.ATTACHMENT_IMG_ATTR = ATTACHMENT_IMG_ATTR;
var BACKGROUND_IMG_ATTR = 'data-background-image-url';
exports.BACKGROUND_IMG_ATTR = BACKGROUND_IMG_ATTR;

function useLazyLoadImageContainer(_ref, deps) {
  var ref = _ref.ref,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options,
      onLoad = _ref.onLoad;
  (0, _react.useEffect)(function () {
    if (ref.current && onLoad) {
      var externalImages = Array.from(ref.current.querySelectorAll('img[data-src]'));
      var backgroundImages = Array.from(ref.current.querySelectorAll('[data-background-image-url]'));
      var attachmentImages = Array.from(ref.current.querySelectorAll('img[cid]'));
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio <= 0.1) return;
          var node = entry.target; // Skip the loaded elements

          if (!!node.getAttribute('src')) return;
          if (!!node.style.backgroundImage) return;
          new Promise(function (_, reject) {
            var src = '';

            switch (true) {
              // Load the inline attachment image
              case (src = node.getAttribute(ATTACHMENT_IMG_ATTR), !!src && !errorCaches.has(src)):
                onLoad(src, node, ATTACHMENT_IMG_ATTR);
                node.removeAttribute(ATTACHMENT_IMG_ATTR);
                break;
              // Load the image with external link

              case (src = node.getAttribute(EXTERNAL_IMG_ATTR), !!src && !errorCaches.has(src)):
                onLoad(src, node, EXTERNAL_IMG_ATTR);
                node.removeAttribute(EXTERNAL_IMG_ATTR);
                break;
              // Load the image set at background image

              case (src = node.getAttribute(BACKGROUND_IMG_ATTR), !!src && !errorCaches.has(src)):
                onLoad(src, node, BACKGROUND_IMG_ATTR);
                node.removeAttribute(BACKGROUND_IMG_ATTR);
                break;

              default:
            }
          })["catch"](function (url) {
            return !!url && errorCaches.add(url);
          });
        });
      }, {
        root: options.root || null,
        threshold: options.threshold || 0
      });

      for (var _i = 0, _arr = [].concat((0, _toConsumableArray2["default"])(externalImages), (0, _toConsumableArray2["default"])(attachmentImages), (0, _toConsumableArray2["default"])(backgroundImages)); _i < _arr.length; _i++) {
        var _node = _arr[_i];
        observer.observe(_node);
      }

      return function () {
        observer.disconnect();
      };
    }
  }, deps);
}

var _default = useLazyLoadImageContainer;
exports["default"] = _default;

var useLazyLoadImage = function useLazyLoadImage(ref, onLoad) {
  var dependency = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  (0, _react.useEffect)(function () {
    if (ref.current && onLoad) {
      var observer = new IntersectionObserver(function (changes) {
        changes.forEach(function (change) {
          if (change.intersectionRatio <= 0) return;
          onLoad();
          observer.disconnect();
        });
      });
      observer.observe(ref.current);
      return function () {
        observer.disconnect();
      };
    }
  }, dependency);
};

exports.useLazyLoadImage = useLazyLoadImage;
//# sourceMappingURL=lazyImage.js.map